import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as analyticsAPI from 'api/Settings/index';
import { isEmpty } from 'utils/redux';

const initialState = {
  data: null,
  TabName: 'All',
  selectedTab: '',
  ui: {
    loading: false,
    msg: ''
  },
  status: ''
};
const getAnalyticState = (state) => state.reporting;

const getSetting = createAsyncThunk('setting/getSetting', async () => {
  const res = await analyticsAPI.GetSettingData();
  return res.data?.data;
});

const SettingSlice = createSlice({
  name: 'setting',
  initialState: initialState,

  reducers: {
    resetState: () => {
      return initialState;
    },
    setSelectedTab: (state, action) => {
      state.selectedTab = action.payload;
    }
  },

  extraReducers: {
    [getSetting.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },

    [getSetting.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;

      if (isEmpty(action.payload)) {
        state.data = null;
      } else {
        state.data = action.payload;
      }
    },

    [getSetting.rejected]: (state, action) => {
      console.log(action.error.message, 'action.error.message');
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    }

    // getDownloadReport
  }
});

const { resetState, setSelectedTab } = SettingSlice.actions;

export default SettingSlice.reducer;

export { getSetting, getAnalyticState, resetState, setSelectedTab };
